import { IAuthorities, IUtilityMunicipalInfo } from './../models/jobs';
import axios from '../helpers/axios'
import qs from 'querystring';
import { logError } from '../services';
import {
  IDropdownResponse,
  IJob,
  IJobReassignment,
  IJobReassignmentPut,
  IJobsRes,
  IResponse,
  ISampleContractDocuments,
  IJobList,
  IJobGeneralInfo,
  IJobLotInfo,
  IJobSitePrepInfo,
  IJobHouseInfo,
  IFinanceInfo,
  IContractInfo,
  IContractInfoReadOnly,
  IBulkEditJob,
  IGetBulkEditJobs,
  IUpdateBulkEditJobs,
  IGetBulkEditJobsNextLotNumbers
} from '../models';

export const deletePunchListData = async (
  neighborhoodId: number,
  lotNumber: number
): Promise<any> => {
  try {
    const { data } = await axios.delete(
      `/neighborhoods/${neighborhoodId}/lots/${lotNumber}/punch-list`
    );
    return data;
  } catch (error) {
    logError(error, 'deletePunchListData failed');
    return Promise.reject(error);
  }
};

export const deletePreWalkData = async (
  neighborhoodId: number,
  lotNumber: number
): Promise<any> => {
  try {
    const { data } = await axios.delete(
      `/neighborhoods/${neighborhoodId}/lots/${lotNumber}/pre-walk`
    );
    return data;
  } catch (error) {
    logError(error, 'deletePreWalkData failed');
    return Promise.reject(error);
  }
};

export const getJobs = async (filters?: {
  name?: string;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number;
}): Promise<IJobsRes> => {
  try {
    const { data } = await axios.get(`/api/jobs`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getJobs failed');
    return Promise.reject(error);
  }
};

export const getJob = async (jobId: number): Promise<IJob> => {
  try {
    // const { data } = await axios.get(`/api/jobs/${jobId}`);
    return {
      jobName: 'JobbyJob',
      phase: 'Honeymoon',
      jobSageId: jobId
    };
  } catch (error) {
    logError(error, 'getJob failed');
    return Promise.reject(error);
  }
};

export const getJobStatuses = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/jobs/statuses`);
    return data;
  } catch (error) {
    logError(error, 'getJobStatuses failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getJobTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/jobs/types`);
    return data;
  } catch (error) {
    logError(error, 'getJobTypes failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getJobReassignments = async (filters?: {
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number;
  projectManagerId?: number;
  supervisorId?: number;
}): Promise<IResponse<IJobReassignment[]>> => {
  try {
    const { data } = await axios.get(`/api/jobs/reassignments`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });

    return data;
  } catch (error) {
    logError(error, 'getJobReassignments failed');
    return Promise.reject(error.response.data);
  }
};

export const updateJobReassignments = async (
  jobReassignments: IJobReassignmentPut[]
): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/jobs/reassignments`, {
      jobReassignments: jobReassignments
    });
    return data;
  } catch (error) {
    logError({ error, payload: jobReassignments }, 'updateJobReassignments failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSampleContractDocuments = async (filters?: {
  jobId: number;
  planId: number;
  planElevationId: number;
}): Promise<ISampleContractDocuments[]> => {
  try {
    const { data } = await axios.get(`/api/jobs/sample-contract-documents`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });

    return data;
  } catch (error) {
    logError(error, 'getSampleContractDocuments failed');
    return Promise.reject(error?.response?.data);
  }
};

export const postSampleContractDocuments = async (
  documentTypes: string[],
  filters?: { jobId: number; planId: number; planElevationId: number }
): Promise<any> => {
  try {
    return await axios.post(
      `/api/jobs/sample-contract-documents/generate`,
      {
        documentTypes: documentTypes,
        ...filters
      },
      {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'blob'
      }
    );
  } catch (error) {
    logError({ error }, 'postSampleContractDocuments failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getJobsList = async (filters?: {
  neighborhoodId?: string | number;
  jobStatus?: string;
  jobType?: string;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number | string;
}): Promise<IResponse<IJobList[]>> => {
  try {
    const { data } = await axios.get(`/api/development/jobs`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getJobsList failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getJobGeneralInfo = async (jobId: number | string): Promise<IJobGeneralInfo> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/info/${jobId}`);
    return data;
  } catch (error) {
    logError(error, 'getJobGeneralInfo failed');
    return Promise.reject(error?.response?.data);
  }
};

export const putJobGeneralInfo = async (
  jobId: number | string,
  payload: IJobGeneralInfo
): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/development/jobs/info/${jobId}`, payload);
    return data;
  } catch (error) {
    logError({ error, payload: payload }, 'putJobGeneralInfo failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getNeighborhoodLookup = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/neighborhood-lookup`);
    return data;
  } catch (error) {
    logError(error, 'getNeighborhoodLookup failed');
    return Promise.reject(error?.response?.data);
  }
};

export const createJob = async (
  neighborhoodId: number | string,
  lot: number | string
): Promise<any> => {
  try {
    return await axios.post(`/api/development/jobs`, {
      neighborhoodId: neighborhoodId,
      lot: lot
    });
  } catch (error) {
    logError({ error }, 'createJob failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getJobLotInfo = async (jobId: number | string): Promise<IJobLotInfo> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/lot-info/${jobId}`);
    return data;
  } catch (error) {
    logError(error, 'getJobLotInfo failed');
    return Promise.reject(error?.response?.data);
  }
};

export const createCompactionLetter = async (
  jobId: string | number,
  letterType: string,
  imagePost: FormData
): Promise<string[]> => {
  try {
    const { data } = await axios.post(
      `/api/development/jobs/lot-info/${jobId}/compaction-test-letter/${letterType}`,
      imagePost
    );
    return data;
  } catch (error) {
    logError({ error, payload: imagePost }, 'createCompactionLetter failed');
    return Promise.reject(error);
  }
};

export const getCompactionLetter = async (
  jobId: string | number,
  letterType: string
): Promise<any> => {
  try {
    const { data } = await axios.get(
      `/api/development/jobs/lot-info/${jobId}/compaction-test-letter/${letterType}`,
      { responseType: 'blob' }
    );
    return data;
  } catch (error: any) {
    logError(error, 'getCompactionLetter failed');
    return Promise.reject(error.response.data);
  }
};

export const getCompactionLetterInfo = async (jobId: string | number): Promise<any> => {
  try {
    const { data } = await axios.get(
      `/api/development/jobs/lot-info/${jobId}/compaction-test-letter-info`
    );
    return data;
  } catch (error: any) {
    logError(error, 'getCompactionLetter failed');
    return Promise.reject(error.response.data);
  }
};

export const getSoilConditions = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/soil-conditions`);
    return data;
  } catch (error) {
    logError(error, 'getSoilConditions failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSewerPumpTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/sewer-pump-types`);
    return data;
  } catch (error) {
    logError(error, 'getSewerPumpTypes failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSurveyRequirements = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/survey-requirements`);
    return data;
  } catch (error) {
    logError(error, 'getSurveyRequirements failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getEnvironmentalConcerns = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/environmental-concerns`);
    return data;
  } catch (error) {
    logError(error, 'getEnvironmentalConcerns failed');
    return Promise.reject(error?.response?.data);
  }
};

export const putJobLotInfo = async (jobId: number | string, payload: IJobLotInfo): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/development/jobs/lot-info/${jobId}`, payload);
    return data;
  } catch (error) {
    logError({ error, payload: payload }, 'putJobLotInfo failed');
    return Promise.reject(error?.response?.data);
  }
};

export const validateJobExists = async (jobCode: number | string): Promise<any> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/searchbycode/${jobCode}`);
    return data;
  } catch (error) {
    logError({ error }, 'validateJobExists failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getJobSitePrepInfo = async (jobId: number | string): Promise<IJobSitePrepInfo> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/landscape-info/${jobId}`);
    return data;
  } catch (error) {
    logError(error, 'getJobSitePrepInfo failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getFoundationTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/foundation-types`);
    return data;
  } catch (error) {
    logError(error, 'getFoundationTypes failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSitePrepBudgetLevels = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/site-prep-budget-levels`);
    return data;
  } catch (error) {
    logError(error, 'getSitePrepBudgetLevels failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getClearingLevels = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/clearing-levels`);
    return data;
  } catch (error) {
    logError(error, 'getClearingLevels failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSodMeasuringPoints = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/sod-measuring-points`);
    return data;
  } catch (error) {
    logError(error, 'getSodMeasuringPoints failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getPlantPackages = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/plant-packages`);
    return data;
  } catch (error) {
    logError(error, 'getPlantPackages failed');
    return Promise.reject(error?.response?.data);
  }
};

export const putJobSitePrepInfo = async (
  jobId: number | string,
  payload: IJobSitePrepInfo
): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/development/jobs/landscape-info/${jobId}`, payload);
    return data;
  } catch (error) {
    logError({ error, payload: payload }, 'putJobSitePrepInfo failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getJobHouseInfo = async (jobId: number | string): Promise<IJobHouseInfo> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/house-info/${jobId}`);
    return data;
  } catch (error) {
    logError(error, 'getJobHouseInfo failed');
    return Promise.reject(error?.response?.data);
  }
};

export const putJobHouseInfo = async (
  jobId: number | string,
  payload: IJobHouseInfo
): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/development/jobs/house-info/${jobId}`, payload);
    return data;
  } catch (error) {
    logError({ error, payload: payload }, 'putJobHouseInfo failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getGarageOptions = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/garage-options`);
    return data;
  } catch (error) {
    logError(error, 'getGarageOptions failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getDrivewaySides = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/driveway-sides`);
    return data;
  } catch (error) {
    logError(error, 'getDrivewaySides failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getJobColorExclusionOptions = async (jobId: string | number): Promise<number[]> => {
  try {
    const { data } = await axios.get(
      `/api/development/jobs/house-info/color-exclusion-options/${jobId}`
    );
    return data;
  } catch (error: any) {
    logError(error, 'getJobColorExclusionOptions failed');
    return Promise.reject(error.response.data);
  }
};

export const putJobExcludedColorSchemes = async (
  jobId: number | string,
  payload: number[]
): Promise<any> => {
  try {
    const { data } = await axios.put(
      `/api/development/jobs/house-info/excluded-color-schemes/${jobId}`,
      payload
    );
    return data;
  } catch (error) {
    logError({ error, payload: payload }, 'putJobExcludedColorSchemes failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getJobNeighborhoodSeriesOptions = async (
  jobId: number | string,
  neighborhoodId?: string | number
): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(
      `/api/development/jobs/house-info/neighborhood-series-options`,
      {
        params: {
          jobId,
          neighborhoodId
        },
        paramsSerializer: params => qs.stringify(params)
      }
    );
    return data;
  } catch (error) {
    logError(error, 'getJobNeighborhoodSeriesOptions failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getUtilityMunicipalInfo = async (
  jobId: number | string
): Promise<IUtilityMunicipalInfo> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/utility-municipality-info/${jobId}`);
    return data;
  } catch (error) {
    logError(error, 'getUtilityMunicipalInfo failed');
    return Promise.reject(error?.response?.data);
  }
};

export const putUtilityMunicipalInfo = async (
  jobId: number | string,
  payload: IUtilityMunicipalInfo
): Promise<any> => {
  try {
    const { data } = await axios.put(
      `/api/development/jobs/utility-municipality-info/${jobId}`,
      payload
    );
    return data;
  } catch (error) {
    logError({ error, payload: payload }, 'putUtilityMunicipalInfo failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getAuthorityOptions = async (): Promise<IAuthorities> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/utility-municipality-info/authorities`);
    return data;
  } catch (error: any) {
    logError(error, 'getAuthorityOptions failed');
    return Promise.reject(error.response.data);
  }
};

export const getDrainageOptions = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(
      `/api/development/jobs/utility-municipality-info/drainage-types`
    );
    return data;
  } catch (error: any) {
    logError(error, 'getDrainageOptions failed');
    return Promise.reject(error.response.data);
  }
};

export const getSepticOptions = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(
      `/api/development/jobs/utility-municipality-info/septic-types`
    );
    return data;
  } catch (error: any) {
    logError(error, 'getSepticOptions failed');
    return Promise.reject(error.response.data);
  }
};

export const getWaterHeaterOptions = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(
      `/api/development/jobs/utility-municipality-info/water-heater-types`
    );
    return data;
  } catch (error: any) {
    logError(error, 'getWaterHeaterOptions failed');
    return Promise.reject(error.response.data);
  }
};

export const getFirePlaceOptions = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(
      `/api/development/jobs/utility-municipality-info/fire-place-types`
    );
    return data;
  } catch (error: any) {
    logError(error, 'getFirePlaceOptions failed');
    return Promise.reject(error.response.data);
  }
};

export const getCooktopOptions = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(
      `/api/development/jobs/utility-municipality-info/cooktop-types`
    );
    return data;
  } catch (error: any) {
    logError(error, 'getCooktopOptions failed');
    return Promise.reject(error.response.data);
  }
};

export const getFinanceInfo = async (jobId: number | string): Promise<IFinanceInfo> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/finance-info/${jobId}`);
    return data;
  } catch (error) {
    logError(error, 'getFinanceInfo failed');
    return Promise.reject(error?.response?.data);
  }
};

export const putFinanceInfo = async (
  jobId: number | string,
  payload: IFinanceInfo
): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/development/jobs/finance-info/${jobId}`, payload);
    return data;
  } catch (error) {
    logError({ error, payload: payload }, 'putFinanceInfo failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getContractInfo = async (jobId: number | string): Promise<IContractInfo> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/contract-info/${jobId}`);
    return data;
  } catch (error) {
    logError(error, 'getContractInfo failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getContractInfoReadOnly = async (
  jobId: number | string
): Promise<IContractInfoReadOnly> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/contract-info-read-only/${jobId}`);
    return data;
  } catch (error) {
    logError(error, 'getContractInfoReadyOnly failed');
    return Promise.reject(error?.response?.data);
  }
};

export const putContractInfo = async (
  jobId: number | string,
  payload: IContractInfo
): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/development/jobs/contract-info/${jobId}`, payload);
    return data;
  } catch (error) {
    logError({ error, payload: payload }, 'putContractInfo failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getJobProjectManagers = async (jobId: number | string): Promise<any> => {
  try {
    const { data } = await axios.get(
      `/api/development/jobs/contract-info/project-managers/${jobId}`
    );
    return data;
  } catch (error: any) {
    logError(error, 'getJobProjectManagers failed');
    return Promise.reject(error.response.data);
  }
};

export const getJobSupervisors = async (jobId: number | string): Promise<any> => {
  try {
    const { data } = await axios.get(`/api/development/jobs/contract-info/supervisors/${jobId}`);
    return data;
  } catch (error: any) {
    logError(error, 'getJobSupervisors failed');
    return Promise.reject(error.response.data);
  }
};

export const getBulkEditJobs = async (payload: IGetBulkEditJobs): Promise<IBulkEditJob[]> => {
  try {
    const { data } = await axios.post(`/api/jobs/bulk/get-collection`, payload);
    return data;
  } catch (error: any) {
    logError(error, 'getBulkEditJobs failed');
    return Promise.reject(error.response.data);
  }
};

export const updateBulkEditJobs = async (payload: IUpdateBulkEditJobs[]): Promise<any> => {
  try {
    const { data } = await axios.patch(`/api/jobs/bulk`, payload);
    return data;
  } catch (error: any) {
    logError(error, 'updateBulkEditJobs failed');
    return Promise.reject(error.response.data);
  }
};

export const getBulkNextLotNumbers = async (
  payload: IGetBulkEditJobsNextLotNumbers
): Promise<number[]> => {
  try {
    const { data } = await axios.post(`/api/jobs/bulk/next-lot-numbers`, payload);
    return data;
  } catch (error: any) {
    logError(error, 'getBulkNextLotNumbers failed');
    return Promise.reject(error.response.data);
  }
};
